import $ from 'jquery';

class ScrollElements{

	constructor(){
	
		var self = this;

		$(document).on('scroll', () => {

			$('[data-scroll]').each((index, item) => {
				
				var $item = $(item);
				var offsetTop = $item.offset().top;

		        if(
		        	($item.offset().top < ($(window).scrollTop() + $(window).height()) * 0.9) ||
		        	($(window).scrollTop() >= ($(document).height() - $(window).height()))
		        ){
		        	if(!$item.hasClass('viewed'))
						$item.addClass('viewed');
				}
			})

		})


	}

}

export default ScrollElements;



// WEBPACK FOOTER //
// ./js/components/scrollElements.js